import { styled } from "styled-components";
import {
  breakpointDesktop,
  breakpointTablet,
  Heading1Text,
  Lozenge,
  BodyText,
} from "@gnist/design-system";
import React from "react";
import { numberWithSpaces } from "@/utils/numberWithSpacing";
import { useTradeInContext } from "@/components/tradeIn/tradeInProvider";
import { tokens } from "@gnist/themes/tokens.css.js";

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Prefix = styled.span`
  font-size: ${tokens.typeface.size.l};

  @media screen and (max-width: ${breakpointTablet}) {
    font-size: ${tokens.typeface.size.base};
  }
`;

const HeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.xs};
  justify-content: space-between;
  width: 100%;

  @media screen and (min-width: ${breakpointDesktop}) {
    justify-content: flex-start;
  }
`;

const SoldBanner = styled.div`
  > * {
    padding: ${tokens.spacing.base} ${tokens.spacing.xs};
  }
  p {
    text-transform: capitalize;
  }
`;

interface Props {
  priceText: string;
  priceVal: number;
  isSold: boolean;
  isTradeInEnabled: boolean;
}

export const Price = ({
  priceText,
  priceVal,
  isSold,
  isTradeInEnabled,
}: Props) => {
  const { isTradeInPricingOn, tradeInPrice } = useTradeInContext();
  const totalPriceString = `${numberWithSpaces(priceVal)} kr`;
  const updatedPriceString = `${numberWithSpaces(priceVal - tradeInPrice)} kr`;
  const showTradeInPricing = isTradeInEnabled && isTradeInPricingOn;

  return (
    <>
      <PriceWrapper>
        <BodyText style={{ fontWeight: tokens.typeface.weight.semibold }}>
          {showTradeInPricing ? `${priceText}: ${totalPriceString}` : priceText}
        </BodyText>
        <HeadlineWrapper>
          <Heading1Text>
            {showTradeInPricing && <Prefix>Din pris </Prefix>}
            {showTradeInPricing ? updatedPriceString : totalPriceString}
          </Heading1Text>
          {isSold && (
            <SoldBanner>
              <Lozenge colorVariant="warning">
                <p>Solgt</p>
              </Lozenge>
            </SoldBanner>
          )}
        </HeadlineWrapper>
      </PriceWrapper>
    </>
  );
};
